const STAR_COLOR = 'rgb(37, 68, 49)';
const REVIEWS_SELECTOR = '.product-title-block__reviews--ab-inline-only';

const isAbActive = () =>
  document.documentElement.classList.contains('ig-buybox-redesign') ||
  document.body.classList.contains('ig-buybox-redesign');

const applyStarStyles = (stars) => {
  stars.style.setProperty('--oke-stars-foregroundColor', STAR_COLOR);
  stars.style.setProperty('--oke-stars-borderColor', STAR_COLOR);
  stars.style.setProperty('--oke-stars-borderWidth', '0');
};

const fixStarSymbol = () => {
  const symbol = document.getElementById('oke-star-filled');
  if (!symbol) return;

  const path = symbol.querySelector('path');
  if (!path) return;

  path.setAttribute('fill', STAR_COLOR);
  path.style.setProperty('fill', STAR_COLOR, 'important');
};

const applyAbBuyboxOkendo = () => {
  if (!isAbActive()) return;

  const containers = document.querySelectorAll(REVIEWS_SELECTOR);

  for (const container of containers) {
    for (const stars of container.querySelectorAll('.oke-stars')) {
      applyStarStyles(stars);
    }
  }

  fixStarSymbol();
};

const observeOkendoRender = () => {
  if (!isAbActive()) return;

  const ratingRoots = document.querySelectorAll(`${REVIEWS_SELECTOR} [data-oke-star-rating]`);

  for (const root of ratingRoots) {
    if (root.dataset.abOkendoObserved === 'true') continue;

    root.dataset.abOkendoObserved = 'true';

    const observer = new MutationObserver(() => {
      applyAbBuyboxOkendo();
    });

    observer.observe(root, { childList: true, subtree: true, attributes: true });
  }

  applyAbBuyboxOkendo();
};

const observeAbClass = () => {
  const handleClassChange = () => {
    if (isAbActive()) {
      observeOkendoRender();
    }
  };

  const observer = new MutationObserver(handleClassChange);

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    observeOkendoRender();
    observeAbClass();
  });
} else {
  observeOkendoRender();
  observeAbClass();
}
